import ProductsHero from './components/ProductsHero';
import ProductCategories from './components/ProductCategories';
import MoringaNutrition from './components/MoringaNutrition';
import MoringaFAQ from './components/MoringaFAQ';
import MoringaTestimonials from './components/MoringaTestimonials';
import TrainingPrograms from './components/TrainingPrograms';
import ConsultancyServices from './components/ConsultancyServices';
import ExportServices from './components/ExportServices';
import ProductInquiry from './components/ProductInquiry';
import SEO from '../../components/SEO';

export default function Products() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "name": "BSF Products & Pure Moringa Powder | MY AVA Farms Ghana",
        "description": "MY AVA Farms offers BSF training programs, Black Soldier Fly larvae, organic fertilizer, insect protein meal, pure moringa powder, consultancy services, and export services in Accra Ghana",
        "url": `${siteUrl}/products`,
        "publisher": {
          "@type": "Organization",
          "name": "MY AVA Farms",
          "url": siteUrl,
          "logo": {
            "@type": "ImageObject",
            "url": "https://static.readdy.ai/image/3ca3a64fdbdd1a27f61611d5a6ab11d4/19d8f85f961deb0bcb56f566b071f178.jpeg"
          }
        },
        "mainEntity": {
          "@type": "ItemList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "BSF Training Programs", "url": `${siteUrl}/products` },
            { "@type": "ListItem", "position": 2, "name": "Black Soldier Fly Larvae", "url": `${siteUrl}/products` },
            { "@type": "ListItem", "position": 3, "name": "Organic Fertilizer", "url": `${siteUrl}/products` },
            { "@type": "ListItem", "position": 4, "name": "Pure Moringa Powder", "url": `${siteUrl}/products/moringa-powder` }
          ]
        }
      },
      {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": siteUrl },
          { "@type": "ListItem", "position": 2, "name": "Products", "item": `${siteUrl}/products` }
        ]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          { "@type": "Question", "name": "What is the recommended daily dosage of moringa powder?", "acceptedAnswer": { "@type": "Answer", "text": "For adults, 1–2 teaspoons (3–6g) per day is recommended. Start with ½ teaspoon and gradually increase. Best taken in the morning added to warm water, a smoothie, or porridge. Do not exceed 2 tablespoons (10g) per day." } },
          { "@type": "Question", "name": "Is moringa powder safe for children?", "acceptedAnswer": { "@type": "Answer", "text": "Yes. For children aged 1–5, start with ¼ teaspoon (1g) per day. Children aged 6–12 can take ½ teaspoon daily. It is particularly beneficial for growing children due to its calcium, iron, and vitamin A content." } },
          { "@type": "Question", "name": "How should I store moringa powder?", "acceptedAnswer": { "@type": "Answer", "text": "Store in a sealed, airtight container away from direct sunlight, heat, and moisture. A cool, dry cupboard works perfectly. No refrigeration needed. Shelf life is 24 months when stored correctly." } },
          { "@type": "Question", "name": "Is your moringa powder 100% pure with no additives?", "acceptedAnswer": { "@type": "Answer", "text": "Yes — our Pure Moringa Powder contains one ingredient: moringa leaves. No fillers, additives, preservatives, artificial colours or flavours, and no added sugar. Grown in Ghana without synthetic pesticides or chemical fertilisers." } },
          { "@type": "Question", "name": "How soon will I notice health benefits from taking moringa powder?", "acceptedAnswer": { "@type": "Answer", "text": "Most people notice improved energy within 1–2 weeks. Longer-term benefits such as stronger immunity and improved iron levels are typically noticeable after 4–8 weeks of consistent daily use." } }
        ]
      }
    ]
  };

  return (
    <>
      <SEO
        title="BSF Products & Pure Moringa Powder | MY AVA Farms Ghana"
        description="MY AVA Farms offers pure moringa powder, BSF training programs, Black Soldier Fly larvae, organic fertilizer, insect protein meal, consultancy services, and export services in Accra Ghana. Sustainably grown and processed."
        keywords="pure moringa powder Ghana, moringa powder Accra, BSF training Ghana, Black Soldier Fly larvae Accra, organic fertilizer Ghana, insect protein meal, BSF consultancy Ghana, moringa superfood Ghana"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <ProductsHero />
        <TrainingPrograms />
        <ProductCategories />
        <MoringaNutrition />
        <MoringaFAQ />
        <MoringaTestimonials />
        <ConsultancyServices />
        <ExportServices />
        <ProductInquiry />
      </div>
    </>
  );
}
